import { initI18n } from '@wix/wix-i18n-config';

export default function i18n({ locale, resources }) {
  return initI18n({
    locale,
    messages: resources
  });
}
